import { render, staticRenderFns } from "./CompanyShowShortHistory.vue?vue&type=template&id=5fe42c31&"
import script from "./CompanyShowShortHistory.vue?vue&type=script&lang=js&"
export * from "./CompanyShowShortHistory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports